module.exports = "<svg ng-attr-width=\"{{$ctrl.size || 32}}px\" ng-attr-height=\"{{$ctrl.size || 32}}px\" viewBox=\"0 0 66 66\" xmlns=http://www.w3.org/2000/svg> <circle fill=none stroke-width=6 stroke-linecap=round cx=33 cy=33 r=30> </circle> </svg> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/spinner/spinner.template.html
// module id = 567
// module chunks = 0